import React from "react";
import { Route, Routes } from "react-router-dom";
import AddBooking from "./components/Booking/AllBooking/AddBooking";
import AllBooking from "./components/Booking/AllBooking/AllBooking";
import Button from "./components/Button/Button";
import Contact from "./components/Contact/Contact";
import Dashboard from "./components/Dashboard/Dashboard";
import Layout from "./components/Layout/Layout";
import AddProduct from "./components/Product/AddProduct";
import AddProject from "./components/Project/AddProject";
import AllProject from "./components/Project/AllProject";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Dashboard />}></Route>
          <Route path="/button" element={<Button />}></Route>
          <Route path="/booking/all-booking" element={<AllBooking />}></Route>
          <Route path="/booking/add-booking" element={<AddBooking />}></Route>
          <Route path="/Product/add-product" element={<AddProduct />}></Route>
          <Route path="/product/all-product" element={<AddBooking />}></Route>
          <Route path="/booking/add-booking" element={<AddBooking />}></Route>
          <Route path="/project/add-project" element={<AddProject />}></Route>
          <Route path="/project/all-project" element={<AllProject />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
